import { Injectable } from '@angular/core';
import {BaseService} from './base.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {Observable, Subject} from 'rxjs';
import {AppUrl} from '../constants/app-url';

declare var Razorpay: any;
@Injectable({
  providedIn: 'root'
})
export class RazorpayService  extends BaseService{
  private  readonly razorpayOptions: any = {
    key: 'rzp_live_apkZMRqYfUeHir',
    currency: 'INR',
    description: 'AXICO HEALTH CARE PRIVATE LIMITED',
    image: 'https://www.axicoayurveda.com/assets/images/AxicoAyurveda1.webp',
    prefill: {
      name: '',
      email: '',
      contact: '',
    },
    handler: async (response: any) => {
      if(response.razorpay_payment_id) {
        this.paymentResponseSubject.next(response);
      }

    },
    notes: {
      address: 'AXICO HEALTH CARE PRIVATE LIMITED',
    },
    theme: {
      color: '#436A3C',
    },
  };
  private razorpay: any;
  private paymentResponseSubject = new Subject<any>();
  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService,) {
    super(http, alertService, globalService);

  }

  genrateOrderId(data): Observable<any> {
    return this.postRequest(AppUrl.GENRATE_ORDER_ID(),data);
  }
  initializePayment(data: any) {
    this.razorpayOptions.amount = data.amount;
    this.razorpayOptions.name = data.name;
    this.razorpayOptions.prefill.name = data.name;
    this.razorpayOptions.prefill.email = data.email;
    this.razorpayOptions.prefill.contact = data.contact;
    this.razorpayOptions.order_id = data.order_id;
    this.razorpay = new Razorpay(this.razorpayOptions);
    this.razorpay.open(this.razorpayOptions);
  }
  getPaymentResponseObservable(): Observable<any> {
    return this.paymentResponseSubject.asObservable();
  }
}
